/*
 * transfer 穿梭框
 * author zhousheng
 */
import * as React from 'react';
import { createWorker } from '../_util/createWorker';
import Loading from '../loading';
import Checkbox from '../checkbox';
import Table from '../table';
import Search from '../search';
import SourceList from './SourceList';
const defaultFilterOption = (inputValue, option) => option.title.indexOf(inputValue) > -1;
const defaultTableFilterOption = (inputValue, option) => option.key.indexOf(inputValue) > -1;
const DataSource = (props) => {
    const { prefixCls, displayType, columns, pagination, expansionSource, showSelectAll = true, filterOption: filterOptionProp, showSearch, showSearchClear = true, useWorker = false, tKeys, setTKeys, loading, setLoading, workerLimit = 100000, workerLoading = true, leftStyle, locale, searchMode = 'fe', onSearch, tableLeftProps = {}, searchLeftProps = {}, labelRender } = props;
    const filterOption = filterOptionProp
        || (displayType === 'table' ? defaultTableFilterOption : defaultFilterOption);
    const dataSourceCls = `${prefixCls}-datasource`;
    const { sourceTitle, searchPlaceholder, sourceNoData, sourceNoSearchData, workerLoadingTip } = locale;
    // 搜索关键字
    const [searchValue, setSearchValue] = React.useState('');
    const [totalSelectedUndisabledKeys, setTotalSelectedUndisabledKeys] = React.useState([]);
    const [totalSelectedDisabledKeys, setTotalSelectedDisabledKeys] = React.useState([]);
    const filterSource = React.useMemo(() => {
        if (searchValue === '' || searchMode === 'api') {
            return expansionSource;
        }
        // 需要双层clone
        const cloneSource = expansionSource.map(exs => {
            return Object.assign({}, exs);
        });
        const fileterCloneSource = cloneSource.filter(data => {
            if (data.group) {
                return filterOption(searchValue, data)
                    || data.children.some(child => filterOption(searchValue, child));
            }
            if (data.groupOption) {
                const parentData = cloneSource.find(cData => cData.key === data.groupKey);
                return filterOption(searchValue, data)
                    || filterOption(searchValue, parentData);
            }
            return filterOption(searchValue, data);
        });
        fileterCloneSource.forEach(data => {
            if (data.group) {
                // eslint-disable-next-line max-nested-callbacks
                const filterChildren = data.children.filter(child => fileterCloneSource.some(s => s.key === child.key));
                data.children = filterChildren;
                data.childrenKeys = filterChildren.map(c => c.key);
                data.disabled = data.disabled || data.children.every(child => child.disabled);
            }
        });
        return fileterCloneSource;
    }, [searchValue, expansionSource, displayType, filterOption]);
    const totalUndisabledKeys = React.useMemo(() => {
        const unDisabledDataSource = filterSource.filter(data => !data.group && !data.disabled);
        const udd = unDisabledDataSource.map(data => data.key);
        return udd;
    }, [filterSource]);
    const totalDisabledKeys = React.useMemo(() => {
        const disabledDataSource = filterSource.filter(data => !data.group && !!data.disabled);
        const tdk = disabledDataSource.map(data => data.key);
        return tdk;
    }, [filterSource]);
    React.useEffect(() => {
        const tukSet = new Set(totalUndisabledKeys);
        const tdkSet = new Set(totalDisabledKeys);
        if (useWorker && tKeys.length >= workerLimit && totalUndisabledKeys.length >= workerLimit) {
            workerLoading && setLoading(true);
            const tsuWorker = createWorker(e => {
                const { tKeys, tukSet } = e.data;
                const tsu = [];
                const tsd = [];
                tKeys.forEach(key => {
                    if (tukSet.has(key)) {
                        tsu.push(key);
                    }
                    else if (tdkSet.has(key)) {
                        tsd.push(key);
                    }
                });
                self.postMessage({ tsu, tsd });
            });
            tsuWorker.addEventListener('message', function (event) {
                const { tsu, tsd } = event.data;
                setTotalSelectedUndisabledKeys(tsu);
                setTotalSelectedDisabledKeys(tsd);
                tsuWorker.terminate();
                workerLoading && setLoading(false);
            });
            tsuWorker.postMessage({ tKeys, tukSet });
        }
        else {
            const tsu = [];
            const tsd = [];
            tKeys.forEach(key => {
                if (tukSet.has(key)) {
                    tsu.push(key);
                }
                else if (tdkSet.has(key)) {
                    tsd.push(key);
                }
            });
            setTotalSelectedUndisabledKeys(tsu);
            setTotalSelectedDisabledKeys(tsd);
        }
    }, [totalUndisabledKeys, tKeys, useWorker, workerLimit, workerLoading]);
    const allChecked 
    // 兜底处理下 0 的情况
    = totalUndisabledKeys.length > 0
        && totalUndisabledKeys.length === totalSelectedUndisabledKeys.length;
    const indeterminate = totalSelectedUndisabledKeys.length
        && totalUndisabledKeys.length > totalSelectedUndisabledKeys.length;
    const selectAll = React.useCallback(() => {
        let newTKeys = [];
        // 取消全选
        if (allChecked) {
            const tukSet = new Set(totalUndisabledKeys);
            if (useWorker && tKeys.length > workerLimit && totalUndisabledKeys.length >= workerLimit) {
                workerLoading && setLoading(true);
                const cancelAllWorker = createWorker(e => {
                    const { tKeys, tukSet } = e.data;
                    const nKeys = tKeys.filter(key => !tukSet.has(key));
                    self.postMessage(nKeys);
                });
                cancelAllWorker.addEventListener('message', function (event) {
                    setTKeys(event.data);
                    cancelAllWorker.terminate();
                    workerLoading && setLoading(false);
                });
                cancelAllWorker.postMessage({ tKeys, tukSet });
            }
            else {
                // newTKeys = tKeys.filter(key => !totalUndisabledKeys.includes(key));
                newTKeys = tKeys.filter(key => !tukSet.has(key));
                setTKeys(newTKeys);
            }
        }
        else {
            newTKeys = [...new Set([...tKeys, ...totalUndisabledKeys])];
            setTKeys(newTKeys);
        }
    }, [
        expansionSource,
        totalSelectedUndisabledKeys,
        totalUndisabledKeys,
        useWorker,
        workerLimit,
        workerLoading,
        allChecked,
        tKeys
    ]);
    const searchChange = React.useCallback(e => {
        const searchValue = searchMode === 'fe' ? e.target.value : e;
        setSearchValue(searchValue);
        onSearch === null || onSearch === void 0 ? void 0 : onSearch('left', searchValue);
    }, [onSearch, searchMode]);
    const onSelectChange = v => {
        // 排除filter中包含的tKeys，记为noneFilterKeys
        // 联合noneFilterKeys与filter中的选择项，记为最终keys
        const noneFilterKeys = tKeys.filter(key => !filterSource.some(item => item.key === key));
        setTKeys([...noneFilterKeys, ...v]);
    };
    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys: tKeys,
        getCheckboxProps: record => ({
            disabled: !!record.disabled
        })
    };
    const searchProps = React.useMemo(() => {
        if (searchMode === 'fe') {
            return {
                onChange: searchChange
            };
        }
        return {
            onSearch: searchChange
        };
    }, [searchMode, searchChange]);
    const selectedCount = totalSelectedUndisabledKeys.length + totalSelectedDisabledKeys.length;
    const totalCount = totalUndisabledKeys.length + totalSelectedDisabledKeys.length;
    return (<Loading loading={loading} tip={workerLoadingTip} size="small">
            <div className={dataSourceCls} style={leftStyle}>
                <div className={`${dataSourceCls}-header`}>
                    {showSelectAll && displayType === 'single' && <Checkbox checked={allChecked} indeterminate={indeterminate} className={`${dataSourceCls}-header-checkall`} onClick={selectAll}/>}
                    <span className={`${dataSourceCls}-label`}>
                        {sourceTitle} {typeof labelRender === 'function' ? labelRender(selectedCount, totalCount) : (labelRender || `${selectedCount}/${totalCount}`)}
                    </span>
                </div>
                <div className={`${dataSourceCls}-body`}>
                    {(showSearch === true || showSearch === 'left') && <Search placeholder={searchPlaceholder} className={`${dataSourceCls}-search`} allowClear={showSearchClear} size="small" {...searchProps} {...searchLeftProps}/>}
                    {displayType === 'table' && <div className={`${prefixCls}-table-box`}>
                        <Table pagination={pagination || false} dataSource={filterSource} columns={columns} rowSelection={rowSelection} {...tableLeftProps}/>
                    </div>}
                    {!!filterSource.length && displayType === 'single' && (<SourceList {...props} filterSource={filterSource}/>)}
                    {filterSource.length === 0 && displayType === 'single' && <p className={`${dataSourceCls}-nodata`}>
                        <span>{searchValue === '' ? sourceNoData : sourceNoSearchData}</span>
                    </p>}
                </div>
            </div>
        </Loading>);
};
export default DataSource;
